"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDictionaryColumns = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../table/table-cells");
const authored_columns_1 = require("../authored-evidence/authored-columns");
function useDictionaryColumns() {
    const intl = (0, react_intl_1.useIntl)();
    const { columnCreated, columnCreatedBy, columnUpdated, columnUpdatedBy } = (0, authored_columns_1.useAuthoredColumns)();
    const columnOrder = (0, react_1.useMemo)(() => ({
        datakey: 'order',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_ORDER',
            defaultMessage: 'Pořadí',
        }),
        width: 100,
        CellComponent: table_cells_1.TableCells.NumberCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const columnName = (0, react_1.useMemo)(() => ({
        datakey: 'name',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_NAME',
            defaultMessage: 'Název',
        }),
        width: 200,
        CellComponent: table_cells_1.TableCells.TextCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const columnValidFrom = (0, react_1.useMemo)(() => ({
        datakey: 'validFrom',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_VALID_FROM',
            defaultMessage: 'Platnost od',
        }),
        width: 150,
        CellComponent: table_cells_1.TableCells.DateTimeCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const columnValidTo = (0, react_1.useMemo)(() => ({
        datakey: 'validTo',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_VALID_TO',
            defaultMessage: 'Platnost do',
        }),
        width: 150,
        CellComponent: table_cells_1.TableCells.DateTimeCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const columnActive = (0, react_1.useMemo)(() => ({
        datakey: 'active',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_ACTIVE',
            defaultMessage: 'Aktivní',
        }),
        width: 100,
        CellComponent: table_cells_1.TableCells.BooleanCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const columnCode = (0, react_1.useMemo)(() => ({
        datakey: 'code',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_CODE',
            defaultMessage: 'Kód',
        }),
        width: 100,
        CellComponent: table_cells_1.TableCells.TextCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const dictionaryColumns = (0, react_1.useMemo)(() => [
        columnOrder,
        columnName,
        columnValidFrom,
        columnValidTo,
        columnActive,
        columnCode,
        columnCreated,
        columnCreatedBy,
        columnUpdated,
        columnUpdatedBy,
    ], [
        columnActive,
        columnCode,
        columnName,
        columnOrder,
        columnValidFrom,
        columnValidTo,
        columnCreated,
        columnCreatedBy,
        columnUpdated,
        columnUpdatedBy,
    ]);
    return {
        columnOrder,
        columnName,
        columnValidFrom,
        columnValidTo,
        columnActive,
        columnCode,
        columnCreated,
        columnCreatedBy,
        columnUpdated,
        columnUpdatedBy,
        dictionaryColumns,
    };
}
exports.useDictionaryColumns = useDictionaryColumns;
//# sourceMappingURL=dictionary-columns.js.map